export default "__VITE_ASSET__BBTxVAj0__"